import { IRolAcceso } from "src/app/shared/models/item.model";

export class CModuloRolSeleccionado implements IRolAcceso {
  codigo_modulo:string | null='' ;
  nombre_modulo:string='';
  rol: string='';
  acceso: string[]=[];
  personalizado?: boolean | undefined;
}
